import React, { useCallback } from 'react';

import CN from 'components/experiment/hooks/HooksPage.module.scss';
import Button from 'components/form/Button.component';
import Space from 'components/generic/Space.component';
import useTip from 'hooks/useTip.hook';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import delayed from 'utils/functions/delayed.util';
import logger from 'utils/logger.util';

const L = logger('ResetExample');

const RESET_INSIDE = true;

const ResetExample = ({ counter, onChange, onIncrement }) => {
  const { val: isLoading, yay: startLoading, nay: stopLoading } = useTip(false);
  const fastReset = useCallback(() => onChange(0), [onChange]);
  const slowReset = useCallback(() => {
    L.debug('()', 'start outside', isLoading);
    startLoading();
    delayed(10000, () => {
      L.debug('()', 'start inside', isLoading);
      onChange(0);
      RESET_INSIDE && stopLoading();
      L.debug('()', 'stop inside', isLoading);
    });
    L.debug('()', 'stop outside', isLoading);
    !RESET_INSIDE && stopLoading();
  }, [isLoading, onChange, startLoading, stopLoading]);

  L.debug('()', { counter, isLoading });

  return (
    <div data-bem="ResetExample" className={CN.col}>
      <p>
        <Space>The counter is: {fromAnyToTrimmed(counter)}</Space>
        {isLoading && <Space>(awaiting reset)</Space>}
      </p>
      <div className={CN.row}>
        <Button onClick={onIncrement} variant="primary" casing="dialog">
          bump
        </Button>
        <Button onClick={fastReset} variant="secondary">
          fast reset
        </Button>
        <Button onClick={slowReset} variant="secondary" variantInvert>
          slow reset
        </Button>
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default ResetExample;
